import { Trans, useTranslation } from 'react-i18next';

export interface ExportSpaceConfirmationModalContentProps {
  /**
   * Export mode, default "exportSpace"
   */
  mode?: 'exportSpace' | 'exportCTD';
}

const contentTranslationKeys = {
  exportSpace: 'SpaceSynchronization.Export.ExportSpace.Content',
  exportCTD: 'SpaceSynchronization.Export.ExportCtd.Content',
};

export const ExportSpaceConfirmationModalContent = ({
  mode = 'exportSpace',
}: ExportSpaceConfirmationModalContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <Trans
          i18nKey={contentTranslationKeys[mode]}
          components={{
            1: <strong />,
          }}
        />
      </p>
      <p className="mt-5">{t('SpaceSynchronization.Export.Paragraph')}</p>
    </>
  );
};

export default ExportSpaceConfirmationModalContent;
